import { render, staticRenderFns } from "./bookdetail.vue?vue&type=template&id=3c702a5c&scoped=true"
import script from "./bookdetail.vue?vue&type=script&lang=js"
export * from "./bookdetail.vue?vue&type=script&lang=js"
import style0 from "./bookdetail.vue?vue&type=style&index=0&id=3c702a5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c702a5c",
  null
  
)

export default component.exports